<template>
  <div>
    <center>
      <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
      <h1>All Incidents</h1>
       <p v-if="viewSelector">Using the selectors below, choose the incidents that you want to appear</p>
    </center>
    <div v-if="viewSelector">
      <center>
        <hr>
        <v-date-picker v-model="dateSelected" class="calendar" :min="minDate" :max="maxDate"></v-date-picker>
        <v-select class="selectors" v-model="selectedArea" :items="areaSupported" label="Select Area"></v-select>
        <v-select class="selectors" v-model="selectedService" :items="servicesArray" label="Select Service"></v-select>
        <v-radio-group class="mapOrList" v-model="mapOrList" mandatory>
          <v-radio label="List" value="list"></v-radio>
          <v-radio label="Map" value="map"></v-radio>
        </v-radio-group>
        <v-btn id="continueButton" color="success" @click="getIncidents()">Continue</v-btn>
      </center>
    </div>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    incidents: [],
    servicesArray: [],
    areaSupported: [],
    areaIDarray: [],
    selectedService: "All",
    selectedArea: null,
    dateSelected: "2021-01-16",
    minDate: "2021-01-02",
    maxDate: "2021-01-16",
    viewIncidents: false,
    viewSelector: true,
    mapOrList: null,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  async created(){
      if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    window.scrollTo(0,0);
    this.loading = true;

    const areaResponse = await fetch(localStorage.apiURL+"/app/area-supported", {
      method: "GET",
      headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
    });

    const areaData = await areaResponse.json();
  
    this.areaSupported = areaData.areaArray;
    this.supportedAreaIDs = areaData.areaIDarray;
    this.servicesArray = ['All', 'Fire', 'Medical', 'Other']
    this.selectedArea = localStorage.areaName;

    const today = new Date();
    const dateDay = String(today.getDate()).padStart(2, "0");
    const dateMonth = String(today.getMonth() + 1).padStart(2, "0");
    const dateYear = today.getFullYear();

    this.maxDate = dateYear + '-' + dateMonth + '-' + dateDay;
    this.minDate = dateYear + "-01-01";
    this.dateSelected = this.maxDate;

    this.loading = false;

  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async getIncidents(){
      this.loading = true;
      const areaIndex = this.areaSupported.indexOf(this.selectedArea);
      const areaID = this.supportedAreaIDs[areaIndex];
      if(this.dateSelected == this.maxDate){
        this.dateSelected = 'today';
      }
      if (this.mapOrList == "list"){
        this.$router.push({path: 'incidents', query: {area: areaID, service: this.selectedService, date: this.dateSelected}});
      } else {
        if (localStorage.paid_user != 'true'){
          this.loading = false;
          this.error("Incident map is a premium feature. Go Premium!")
          return
        }
        this.$router.push({path: 'incidentMap', query: {area: areaID, service: this.selectedService, date: this.dateSelected}});
      }
    }
  },
};
</script>

<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}

p{
  margin: 0;
}
.selectors{
  margin-top: 35px;
  width: 350px;
}
.mapOrList{
  margin-top: 10px;
  width: 350px;
}
.calendar{
  margin-top: 50px;
}
#continueButton{
  margin-bottom: 10%;
}

</style>
